import { render, staticRenderFns } from "./TableOnly.vue?vue&type=template&id=710662a2&"
import script from "./TableOnly.vue?vue&type=script&lang=js&"
export * from "./TableOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports